// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-widget-content-forum-listing .widget-list-item-item {
  margin-bottom: 5px;
}
.fi-widget-content-forum-listing .widget-list-item-item .widget-list-item-header {
  font-size: 14px;
}
.fi-widget-content-forum-listing .widget-list-item-item .widget-list-item-summary {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./Source/app/widget/widget-content/forum-listing/forum-listing.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AACQ;EACI,eAAA;AACZ;AACQ;EACI,eAAA;AACZ","sourcesContent":[".fi-widget-content-forum-listing {\r\n    .widget-list-item-item {\r\n        margin-bottom: 5px;\r\n        .widget-list-item-header {\r\n            font-size: 14px;\r\n        }\r\n        .widget-list-item-summary {\r\n            font-size: 12px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
